<template>
  <nav
    v-if="breadcrumbs.length > 1"
    aria-label="Breadcrumb"
    class="flex items-center gap-1 text-sm min-w-0">
    <template
      v-for="(item, idx) in breadcrumbs"
      :key="item.path">
      <span
        v-if="idx > 0"
        class="text-muted/50">
        <ChevronRight class="w-4 h-4" />
      </span>
      <router-link
        v-if="!item.active"
        :to="item.path"
        class="text-muted hover:text-ink transition-colors truncate">
        {{ item.name }}
      </router-link>
      <span
        v-else
        class="text-ink font-medium truncate">
        {{ item.name }}
      </span>
    </template>
  </nav>
</template>

<script>
import { ref, onMounted } from 'vue'
import router from '@/router'
import { ChevronRight } from '@lucide/vue'

export default {
  name: 'AppBreadcrumb',
  components: { ChevronRight },
  setup() {
    const breadcrumbs = ref([])

    const getBreadcrumbs = () => {
      return router.currentRoute.value.matched
        .filter(route => route.name)
        .map(route => ({
          active: route.path === router.currentRoute.value.path,
          name: route.name,
          path: route.path,
        }))
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return { breadcrumbs }
  },
}
</script>
